export type ResolveSignalHeaderTotalInput = {
  isRejectedSignalsView: boolean;
  isAiApplication: boolean;
  listTotalCount: number;
  unfilteredAllCount?: number;
  domainTreeScopedTotalCount?: number;
};

export const resolveSignalHeaderTotal = ({
  isRejectedSignalsView,
  isAiApplication,
  listTotalCount,
  unfilteredAllCount,
  domainTreeScopedTotalCount,
}: ResolveSignalHeaderTotalInput): number => {
  if (isRejectedSignalsView) {
    return listTotalCount;
  }

  if (isAiApplication) {
    return unfilteredAllCount ?? listTotalCount;
  }

  return domainTreeScopedTotalCount ?? unfilteredAllCount ?? listTotalCount;
};
